import * as React from 'react';
const TreeSelectContext = /*#__PURE__*/React.createContext(null);
export default TreeSelectContext;